import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import products from "./modules/Products/ProductsModule";
import productType from "./modules/Products/ProductTypeModule";
import ProductOverview from "./modules/Products/ProductOverviewModule";
import importProduct from "./modules/Products/ImportProductsModule";
import exportProduct from "./modules/Products/ExportProductsModule";
import produceReport from "./modules/Reports/ProduceReportModules";
import machine from "./modules/MachineModule";
import MachineProduct from "./modules/Machine/MachineProductModule";
import MachineSheet from "./modules/Machine/MachineSheetModule";
import material from "./modules/Materials/MaterialModule";
import FactorialMaterial from "./modules/FactorialMaterial/FactorialMaterialModule";
import FactorialMaterialExport from "./modules/FactorialMaterial/FactorialMaterialExportModule";
import FactorialMaterialImport from "./modules/FactorialMaterial/FactorialMaterialImportModule";
import importMaterial from "./modules/Materials/MaterialImportModule";
import exportMaterial from "./modules/Materials/MaterialExportModule";
import sheet from "./modules/Sheets/SheetModule";
import importSheet from "./modules/Sheets/SheetImportModule";
import exportSheet from "./modules/Sheets/SheetExportModule";
import reportSheet from "./modules/Reports/ReportSheetModule";
import reportProduct from "./modules/Reports/ReportProductModule";
import FactoryEmployeeSale from "./modules/HR/FactoryEmployeeSaleModule";
//Sale manage
import order from "./modules/Sales/OrderModule";
import invoice from "./modules/Sales/InvoiceModule";
import SpecialCustomer from "./modules/Sales/ReportSpecialCustomerModule";
import ExampleProduct from "./modules/Sales/ExampleProductModule";
import ExampleGift from "./modules/Sales/ExampleGiftModule";

import Promotion from "./modules/Sales/PromotionModule";
import PromotionOther from "./modules/Sales/PromotionOtherModule";
import SaveExportation from "./modules/Sales/SaveExportationModule";
import SaleReturnProduct from "./modules/Sales/SaleReturnProductsModule";
import OverViewSale from "./modules/Sales/OverviewForSaleModule";

import vendor from "./modules/Persons/VendorModule";
import transportType from "./modules/Transports/TransportTypeModule";
import Common from "./modules/CommonModule";
import transportation from "./modules/Transports/TransportationModule";
import pdf from "./modules/DownloadPDFModule";
import position from "./modules/Persons/PositionModule";
import MaterialInspect from "./modules/Purchasing/MaterialInspectModule";
import CheckList from "./modules/Purchasing/CheckListModule";
import PreOrder from "./modules/Purchasing/PreOrderModule";
import PurchaseOrder from "./modules/Purchasing/PurchaseOrderModule";
import RROrder from "./modules/Purchasing/RROrderModule";
import CheckBag from "./modules/Purchasing/CheckedBagModule";
import BagData from "./modules/Purchasing/BagDataModule";
import BagType from "./modules/Purchasing/BagTypeModule";

import PurchasePayment from "./modules/Purchasing/PurchasePaymentModule";

import Driver from "./modules/Transports/DriverModule";
import DriverBonus from "./modules/Transports/DriverBonusModule";
import DriverDetails from "./modules/Transports/DriverDetailsModule";
import DriverConfigBonus from "./modules/Transports/DriverConfigBonusModule";
import InsuranceFee from "./modules/Transports/InsuranceModule";
import Deposit from "./modules/Transports/DepositModule";
import Repair from "./modules/Transports/RepairModule";
import Damages from "./modules/Transports/DamagesModule";
import Shipping from "./modules/Transports/ShippingModule";

// Account
import ReceivableSeller from "./modules/Accounting/SellerModule"
import Receivable from "./modules/Accounting/ReceivableModule"
import Billing from "./modules/Accounting/BillingModule"
import Payment from "./modules/Accounting/PaymentModule"
import BillingPayoff from "./modules/Accounting/BillingPayoffModule"
import WaitingPayment from "./modules/Accounting/WaitingPaymentModule"
import ChequeListPayoff from "./modules/Accounting/ChequeListPayoffModule"
import Bank from "./modules/Accounting/BankModule"
import TaxPayoff from "./modules/Accounting/TaxPayoffModule"
import TaxPayment from "./modules/Accounting/TaxPaymentModule"
import TaxInvoice from "./modules/Accounting/TaxInvoiceModule"
import Account from "./modules/Accounting/AccountModule"
import RRPayoff from "./modules/Accounting/RRPayoffModule"
import invoicePayoff from "./modules/Accounting/InvoicePayoffModule"
import BillingRE from "./modules/Accounting/BillingREModule"

// Transaction
import TransactionType from "./modules/Transactions/TransactionTypeModule"

//HR
import Employee from "./modules/HR/EmployeeModule"
import Holiday from "./modules/HR/HolidayModule"
import LeaveDay from "./modules/HR/LeaveDayModule"
import RateBonusSale from "./modules/HR/RateBonusSaleModule"
import RentalFee from "./modules/Salary/RentalFeeModule"
import AdvanceWithdraw from "./modules/Salary/AdvanveWithdrawModule"
import WorkScheduleHistory from "./modules/HR/WorkScheduleHistoryModule"
import RateSalaryHistory from "./modules/HR/RateSalaryHistoryModule"
import WorkScheduleEmployee from "./modules/HR/WorkScheduleEmployeeModule"
import ScanEmployee from "./modules/HR/ScanEmployeeModule"
import ElectricityBill from "./modules/Salary/ElectricityBillModule"
import ShoppingEmployee from "./modules/Salary/ShoppingEmployeeModule"
import AdvancePayment from "./modules/Salary/AdvancePaymentModule"
import AdvancePaymentDetails from "./modules/Salary/AdvancePaymentDetailsModule"
import PaymentSalary from "./modules/Salary/PaymentSalaryModule"
import SocialSecurity from "./modules/Salary/SocialSecurityModule"
import factoryEmployee from "./modules/HR/FactoryEmployeeModule";
import factoryEmployeeImport from "./modules/HR/FactoryEmployeeImportModule";
import factoryEmployeeExport from "./modules/HR/FactoryEmployeeExportModule";

//Dashboard
import Dashboard from "./modules/Dashboard/DashboardModule"

//Person
import customer from "./modules/Persons/CustomerModule";
import seller from "./modules/Persons/SellerModule";
import auth from "./modules/AuthModule";
import overViewSale from "./modules/Sales/OverviewForSaleModule";
import Department from "./modules/Persons/DepartmentModule";

// RealizedGainLoss
import RealizedGainLoss from "./modules/Accounting/RealizedGainLossModule";

// user
import Users from "./modules/Persons/UserModule";

// Standard
import Standard from "./modules/Standard/StandardModule"

Vue.use(Vuex);

const modules = {
    Products: products,
    ProduceReport: produceReport,
    ProductOverview: ProductOverview,
    ImportProduct: importProduct,
    ExportProduct: exportProduct,
    Customer: customer,
    Seller: seller,
    Machine: machine,
    MachineProduct: MachineProduct,
    MachineSheet: MachineSheet,
    Material: material,
    ImportMaterial: importMaterial,
    ExportMaterial: exportMaterial,
    ProductType: productType,
    Sheet: sheet,
    ImportSheet: importSheet,
    ExportSheet: exportSheet,
    ReportSheet: reportSheet,
    ReportProduct: reportProduct,
    Auth: auth,
    Order: order,
    Vendor: vendor,
    TransportType: transportType,
    Invoice: invoice,
    Common: Common,
    Transportation: transportation,
    PDF: pdf,
    Position: position,
    MaterialInspect: MaterialInspect,
    CheckList: CheckList,
    PreOrder: PreOrder,
    PurchaseOrder: PurchaseOrder,
    RROrder: RROrder,
    Driver: Driver,
    DriverBonus: DriverBonus,
    DriverDetails: DriverDetails,
    DriverConfigBonus: DriverConfigBonus,
    InsuranceFee: InsuranceFee,
    Deposit: Deposit,
    Repair: Repair,
    Damages: Damages,
    Shipping: Shipping,
    CheckBag: CheckBag,
    BagData: BagData,
    PurchasePayment: PurchasePayment,
    ReceivableSeller: ReceivableSeller,
    Receivable: Receivable,
    Billing: Billing,
    Payment: Payment,
    Bank: Bank,

    TransactionType: TransactionType,

    BillingPayoff: BillingPayoff,
    RRPayoff: RRPayoff,
    Account: Account,
    WaitingPayment: WaitingPayment,

    Employee: Employee,
    Holiday: Holiday,
    LeaveDay: LeaveDay,
    RentalFee: RentalFee,
    AdvanceWithdraw: AdvanceWithdraw,
    RateBonusSale: RateBonusSale,
    WorkScheduleHistory: WorkScheduleHistory,
    RateSalaryHistory: RateSalaryHistory,
    WorkScheduleEmployee: WorkScheduleEmployee,
    ScanEmployee: ScanEmployee,
    Promotion: Promotion,
    BagType: BagType,
    FactoryEmployee: factoryEmployee,
    FactoryEmployeeExport: factoryEmployeeExport,
    FactoryEmployeeImport: factoryEmployeeImport,

    SaveExportation: SaveExportation,
    InvoicePayoff: invoicePayoff,
    ChequeListPayoff: ChequeListPayoff,
    SaleReturnProduct: SaleReturnProduct,
    Dashboard: Dashboard,
    SpecialCustomer: SpecialCustomer,
    ExampleProduct: ExampleProduct,

    TaxInvoice: TaxInvoice,
    TaxPayoff: TaxPayoff,

    ElectricityBill: ElectricityBill,
    ShoppingEmployee: ShoppingEmployee,
    AdvancePayment: AdvancePayment,
    AdvancePaymentDetails: AdvancePaymentDetails,
    PromotionOther: PromotionOther,
    OverViewSale: OverViewSale,
    PaymentSalary: PaymentSalary,
    SocialSecurity: SocialSecurity,
    TaxPayment: TaxPayment,
    Department: Department,
    FactorialMaterial: FactorialMaterial,
    FactorialMaterialImport: FactorialMaterialImport,
    FactorialMaterialExport: FactorialMaterialExport,
    RealizedGainLoss: RealizedGainLoss,
    ExampleGift: ExampleGift,
    BillingRE: BillingRE,
    FactoryEmployeeSale,
    Users,
    Standard
};

export default new Vuex.Store({
    modules,
    plugins: [createPersistedState({ paths: ["Auth"] })]
});
